/* unplugin-vue-components disabled */import script from "./TravelTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelTable.vue?vue&type=script&setup=true&lang=js"

import "./TravelTable.vue?vue&type=style&index=0&id=4fda8c1e&lang=css"

const __exports__ = script;

export default __exports__